import { Component, OnInit, ViewChild, ElementRef, AfterViewInit  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { debounceTime } from 'rxjs/operators';
import { AssigmentService } from "app/open-api";
import { BillService } from 'app/open-api';
import { ProcessScanedOrders, ChangeBillStateRQ, ScannedBillsPreview, ScannedBill, ScannedBillModel } from  './../../open-api/model/processScanedOrders';   
import Swal from "sweetalert2";

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit, AfterViewInit {
  scanForms: FormGroup;  
  @ViewChild('code') codeInput: ElementRef;
  codeList: string[] = [];
  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  scannedBills: ScannedBillModel[] = [];
  debounceTime = 500;
  page = 1;
  pageSize = 5;
  collectionSize = 0;
  pageScan = 1;
  pageSizeScan = 5;
  collectionSizeScan = 0;
  readyProccess = false;
  public ColumnMode = ColumnMode;
  title: string = "Escanear paquetes";
  isReadyToProcess = false;
  existsCode = false;
  public basicSelectedOption: number = 5;
  error: string = "";

  constructor(    
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private assigmentService: AssigmentService,
    private billService: BillService,
  ) { }

  ngOnInit() {
    this.subscription = this.modelChanged
    .pipe(
      debounceTime(this.debounceTime),
    )
    .subscribe(() => {
      this.functionToBeCalled();
    });
    this.scanForms = this.initFormBuilder();
  }

  ngAfterViewInit() {
    this.codeInput.nativeElement.focus();
  }

  functionToBeCalled() {
    //console.log('Called After 500ms');
  }

  RemoveCode(code){
    const index = this.codeList.findIndex(
      (r) => r === code
    );
    //console.log(shipments, idShipment, index)
    if (index !== -1) {
      this.codeList.splice(index, 1);
    }
    return this.codeList;
  }

  setFocus() {        
    this.codeInput.nativeElement.focus();  
    //console.log(this.codeInput.nativeElement)  
    
  }


  initFormBuilder() {
    return this.formBuilder.group({
      code: [null, Validators.compose([
        Validators.required,        
      ])],      
    });
  }

  changeInput(event){
    this.existsCode = false;
  }

  checkIfNotMatchFormat(codes: string[]){
    let result = false;
    const matchRegex = /^[[a-zA-Z\s,0-9,_.-]{10,18}]*$/; 
    const matchRegex1 = /^(1|2|3|4|5|6|7|8|9)[0-9]{0,6}$/   
    codes.forEach((item, index) => {      
      let found = item.match(matchRegex);  
      let found1 = item.match(matchRegex1);         
      if((found == null ) && (found1 == null))
         result = true;
    })
    return result;
  }

  addCode(){
    if (this.scanForms.controls['code'].value) {      
      const codes: string[] = this.scanForms.controls['code'].value.toString().split("\n");      
      
      if(!this.lookforDuplicateCodeIntoArray(codes)){              
          if(this.checkIfNotMatchFormat(codes)){
             this.existsCode = true;
             this.error = "Existen códigos que no tienen el formato correcto."
          }
          else {
            this.codeList = Object.assign([],codes)
             this.scanForms.controls['code'].setValue(''); 
             this.collectionSize = this.codeList.length; 
             this.setFocus();
             this.existsCode = false;
             this.error = "";            
          }
      }
      else 
      {
        this.existsCode = true;   
        this.error = "Existen códigos duplicados."
      }   
    }       
  }

  GetScannedBillFromRQ(bill: ScannedBill) {    

    let ret: ScannedBillModel = {
      billCode: bill.billCode,
      currentState: bill.billStateCatalogName,
      billId: bill.billId,
      nextState: bill.nextBillStateCatalogName,
      shippingCode: bill.shippingCode,    
      error: bill.error
    };
    return ret;
  }

  ProccessCodes(){
    this.spinner.show();    
    let ids = this.scannedBills.filter(item => item.error == "").map(({ billId })=> (
      billId
    ));

    let params: ChangeBillStateRQ = {
      billsId: ids
    }

    this.billService.processScanedOrdersPost(params).subscribe(
      (response) => {   
        if(response.status == 200) {
          Swal.fire({
            title: `El proceso se ejecutó satisfactoriamente. Se modificaron ${response.countSuccess} facturas.`,
            icon: "success",
            showConfirmButton: false,
            timer: 5000,
            position: "top",
          });
          this.scannedBills = [];
          this.codeList = [];
          this.readyProccess = false;
          this.isReadyToProcess = false;
          this.title = "Escanear paquetes";
        } 
        else 
        {
          Swal.fire({
            title: `Alerta. El proceso se ejecutó con errores.`,
            icon: "error",
            showConfirmButton: false,
            timer: 5000,
            position: "top",
          });
        }
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );

  }

  CheckCodes() {
    this.spinner.show();
    const param: ProcessScanedOrders = {
      codes: this.codeList,
    };
    this.assigmentService.checkScanedOrdersPost(param).subscribe(
      (response) => {
        
        this.readyProccess = true;
        let list = response.scannedBills;
        let countSuccess = 0;
        if (list) {
          //console.log(list)
          list.forEach((row) => {    
            if(row.error == "")      
              countSuccess++;

            let now: ScannedBillModel = this.GetScannedBillFromRQ(row);
            this.scannedBills = this.scannedBills.concat(now);
          });
        }
        this.isReadyToProcess = countSuccess > 0;
        this.collectionSizeScan = this.scannedBills.length;        
        this.title = "Vista previa de paquetes a procesar";
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  Back(): void {
    this.scannedBills = [];
    this.codeList = [];
    this.readyProccess = !this.readyProccess;
    this.title = "Escanear paquetes";
    this.isReadyToProcess = false;
  }

  lookforDuplicateCode(item){   
    let existCode = this.codeList.find(
      ( code ) => code === item
    );
    if (existCode !== null && existCode !== undefined)
       return true;
      return false;
  }


  lookforDuplicateCodeIntoArray(codes: string[]){       
    return new Set(codes).size !== codes.length
  }

  get allcodes(): string[] {    
    return this.codeList.length > 0 ? this.codeList      
      .slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      ) : [];   
}  

get scannedbills(): ScannedBillModel[] {    
  return this.scannedBills.length > 0 ? this.scannedBills      
    .slice(
      (this.pageScan - 1) * this.pageSizeScan,
      (this.pageScan - 1) * this.pageSizeScan + this.pageSizeScan
    ) : [];   
}  

  onPasteCode(event: ClipboardEvent) {
    //console.log(event);
    let clipboardData = event.clipboardData 
                        || (<any>window).clipboardData; //typecasting to any
                        
    let pastedText = clipboardData.getData("text");
    this.modelChanged.next("Akshay Is Awesome")
    //console.log(pastedText);
    
  }

  get f() {
    return this.scanForms.controls;
  }

}
